export default __webpack_public_path__ + "static/media/2.71bb1cdf.jpg";